<!-- Container for views -->
<script setup lang="ts"></script>

<template>
    <div class="px-7 py-7 max-w-[1500px]">
        <slot />
    </div>
</template>

<style scoped></style>
